import { DataTable, Dialog, FormInput, Loader } from "@/components";
import { ConfigureDialogProps } from "./types";
import useConfigureDialog from "./useConfigureDialog";
import { cn, FIXED_WEIGHTS } from "@/lib/utils";
import { ALLOCATIONS, RULE_NAME, VALUE } from "./consts";

const ConfigureDialog = ({
  open,
  setOpen,
  level,
  budgetType,
  configuredData,
  title
}: ConfigureDialogProps) => {
  const {columns, isLoadingLevel,
    isLoadingHierarchy, allocations,
    isAddingRulePending, onSave, isView,
    onToggleCollapse, form, isAdd, isUpdateRulePending} = useConfigureDialog({
    level,
    budgetType,
    configuredData,
    setOpen
  });
  
  return (
    <Dialog
      open={open}
      setOpen={setOpen}
      title={title ?? "Configuration"}
      onSave={form.handleSubmit(onSave)}
      saveText="Save" 
      saveBtnClassName={isView ? "hidden" : ""}     
      contentClassName="lg:!max-w-[700px]"
      isLoading={isAddingRulePending || isUpdateRulePending}
    >
      <div className="flex flex-col gap-3">
        {configuredData?.key == FIXED_WEIGHTS ? <FormInput
          name={RULE_NAME}
          control={form.control}
          isRequired
          placeholder="Please enter"
          label="Rule Name"
          disabled={!isAdd}
        /> : <></>}
        {isLoadingLevel || isLoadingHierarchy ? <Loader /> : 
          allocations?.map((data: any, index: number) => {
            const isCollapsed = data?.isCollapsed;

            const tableData = (data?.children || []).map((child: any, childIdx: number) => ({
              ...child,
              parentFormIndex: index, // Track which parent block this belongs to
              childFormIndex: childIdx, // Track which row sequence index it is
              headerLabel: data?.label,
              formFieldName: `${ALLOCATIONS}.${index}.children.${childIdx}.${VALUE}`, // Adjust path hierarchy if needed
              onToggleCollapse: () => onToggleCollapse(index),
              total: data?.total,
              isCollapsed
            }));

            return (
              <div
                key={data.id}
                className="overflow-hidden rounded-md border border-g-200"
              >
                <DataTable
                  columns={columns}
                  data={tableData || []}
                  className={cn(
                    "shadow-none border-0 bg-transparent overflow-visible [&_td]:!h-[56px] [&_td]:!px-5",
                    isCollapsed && "[&_tbody]:hidden"
                  )}
                  tableWrapperClassName="px-0 bg-white rounded-md overflow-hidden"
                  headerClass={{
                    row: "bg-primary-300 hover:bg-primary-300 border-0",
                    cell: "h-[42px] px-5 font-semibold text-g-500",
                  }}
                  hideFooter
                />
              </div>
            );
          })
        }
      </div>
    </Dialog>
  );
};

export default ConfigureDialog;
